<template>
	<div class="content-wrapper">
		<!-- Content -->
		<div class="spinner-border spinner-border-lg text-primary load-center" role="status" v-if="isLoading">
			<span class="visually-hidden">Loading...</span>
		</div>

		<div class="container flex-grow-1 container-p-y" v-if="!isLoading" style="padding-top: 0px !important;">
			<div v-if="!selectedTraining" class="row">
				<div class="col-md-12 mb-5">
					<div class="card h-100">
						<div class="col-12 col-sm-12 col-lg-12">

							<div class="input-group input-group-merge">
								<span class="input-group-text" id="basic-addon-search31">
									<i class="ri-search-line"></i>
								</span>
								<input
									type="text"
									class="form-control"
									:placeholder="$t('trainings.create.searchPlaceholder')"
									v-model="searchTraining"
									aria-describedby="basic-addon-search31" />
							</div>
						</div>
					</div>
				</div>

				<div class="col-md-12 mb-4">
					<ul class="nav nav-tabs">
						<li class="nav-item">
							<a class="nav-link" :class="{ active: activeCategory === 'all' }"
								@click="activeCategory = 'all'" href="javascript:void(0)">{{ $t('trainings.create.categoryAll') }}</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" :class="{ active: activeCategory === 'security' }"
								@click="activeCategory = 'security'" href="javascript:void(0)">{{ $t('trainings.create.categorySecurity') }}</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" :class="{ active: activeCategory === 'safety' }"
								@click="activeCategory = 'safety'" href="javascript:void(0)">{{ $t('trainings.create.categorySafety') }}</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" :class="{ active: activeCategory === 'dgr' }"
								@click="activeCategory = 'dgr'" href="javascript:void(0)">{{ $t('trainings.create.categoryDGR') }}</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" :class="{ active: activeCategory === 'packs' }"
								@click="activeCategory = 'packs'" href="javascript:void(0)">{{ $t('trainings.create.categoryPacks') }}</a>
						</li>
					</ul>
				</div>

				<div class="col-xs-12 col-xxl-4 col-lg-4 pb-20" v-for="(training, index) in sortedTrainings" :key="index">
					<div class="card h-100">
						<img class="card-img-top" :src="training.previewUrl[0].url" alt="iPhone-bg" />

						<a
							:href="training.publicLink"
							target="_blank"
							style="position: absolute; top: 10px; right: 10px; background: rgba(255,255,255,0.9); width: 30px; height: 30px; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; color: #666cff; font-weight: bold; box-shadow: 0 2px 4px rgba(0,0,0,0.1);"
							data-bs-toggle="tooltip" :data-bs-title="$t('trainings.create.moreInfo')"
						>
							i
						</a>

						<div class="card-body">
							<div class="row mb-6 g-6">
								<div class="col-6">
									<div class="d-flex">
										<div class="avatar flex-shrink-0 me-4">
											<span class="avatar-initial rounded-3 bg-label-primary"
												><i class="ri-calendar-line ri-24px"></i
											></span>
										</div>
										<div>
											<h6 class="mb-0 text-nowrap fw-normal">
												{{ training.validityInYears }} an{{ training.validityInYears > 1 ? 's' : '' }}
											</h6>
											<small>{{ $t('common.validity') }}</small>
										</div>
									</div>
								</div>
								<div class="col-6">
									<div class="d-flex">
										<div class="avatar flex-shrink-0 me-4">
											<span class="avatar-initial rounded-3 bg-label-primary"
												><i class="ri-time-line ri-24px"></i
											></span>
										</div>
										<div>
											<h6 class="mb-0 text-nowrap fw-normal">
												{{
													training.durationInHours < 1
													? Math.round(training.durationInHours * 60) + ' minute' + (Math.round(training.durationInHours * 60) > 1 ? 's' : '')
													: formatDuration(training.durationInHours)
												}}
											</h6>
											<small>{{ $t('common.duration') }}</small>
										</div>
									</div>
								</div>
							</div>
							<a
								href="javascript:void(0);"
								class="btn btn-primary w-100"
								@click="selectTraining(training)"
								v-if="training.isAvailable && !training.displayWarning"
							>
								{{ displayOrderCTAText(training) }}
							</a>
							<a
								href="javascript:void(0);"
								class="btn btn-primary w-100"
								@click="displayWarning(training)"
								v-else-if="training.displayWarning"
							>
								{{ $t('trainings.create.requestAccess') }}
							</a>
							<a href="javascript:void(0);" class="btn btn-label-secondary w-100" v-else disabled="true">
								{{ $t('trainings.create.comingSoon') }}
							</a>
						</div>
					</div>
				</div>

				<div class="card" v-if="!isLoading && sortedTrainings.length === 0">
					<div class="card-body row ">
						<div class="col-sm-12 col-lg-12 text-center px-4">
							<div class="d-flex justify-content-center">
								<div class="avatar avatar-lg mb-4">
									<span class="avatar-initial rounded-3 bg-label-primary">
										<i class="ri-question-mark ri-36px"></i>
									</span>
								</div>
							</div>
							<h4 class="card-title mb-4">{{ $t('trainings.create.noResults') }}</h4>
							<p class="card-text">
								{{ $t('trainings.create.noResultsDescription') }}
								<a href="mailto:alexandre@pika-aero.com">alexandre@pika-aero.com</a>
								<br />
								<br />
								{{ $t('trainings.create.noResultsAddInfo') }}
							</p>
							<a href="mailto:alexandre@pika-aero.com">
								<button class="btn btn-primary mt-5">{{ $t('trainings.create.contactAlexandre') }}</button>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="row" v-if="selectedTraining && !displayEmployees">
				<div class="col-12">
					<div class="card">
						<div
							class="card-header sticky-element bg-label-secondary d-flex justify-content-sm-between align-items-sm-center flex-column flex-sm-row">
							<h5 class="card-title mb-sm-0 me-2">{{ $t('trainings.create.chooseType') }}</h5>
						</div>
						<div class="card-body">
							<div class="row">
								<div class="col-lg-8 mx-auto">
									<h5 class="my-6">{{ $t('trainings.create.languageStep') }}</h5>
									<div class="row gy-3">
										<div class="col-md">
											<div class="form-check custom-option custom-option-icon">
												<select id="defaultSelect" class="form-select" v-model="selectedLanguage">
													<option disabled value="">{{ $t('trainings.create.selectLanguage') }}</option>
													<option
														v-for="lang in selectedTraining.availableLanguages"
														:key="lang"
														:value="lang"
													>
														{{ getLanguageName(lang) }}
													</option>
												</select>
											</div>
										</div>
									</div>
								</div>
								<div class="col-lg-8 mx-auto">

								<!-- 2. Delivery Type -->
									<h5 class="my-6">{{ $t('trainings.create.typeStep') }}</h5>
									<div class="row gy-3">
										<div class="col-md">
											<div class="form-check custom-option custom-option-icon">
												<label class="form-check-label custom-option-content" for="customRadioIcon1">
													<span class="custom-option-body">
														<i class="ri-play-circle-line"></i>
														<span class="custom-option-title mb-2"> {{ $t('common.trainingTypes.initial') }} </span>
														<small>
															{{ $t('trainings.create.initialDescription') }}
														</small>
													</span>
													<input
														name="customDeliveryRadioIcon"
														class="form-check-input"
														type="radio"
														value="initial"
														id="customRadioIcon1"
														v-model="selectedType"
														/>
												</label>
											</div>
										</div>
										<div class="col-md">
											<div class="form-check custom-option custom-option-icon">
												<label class="form-check-label custom-option-content" for="customRadioIcon2">
													<span class="custom-option-body">
														<i class="ri-loop-left-line"></i>
														<span class="custom-option-title mb-2"> {{ $t('common.trainingTypes.renewal') }} </span>
														<small>
															{{ $t('trainings.create.renewalDescription') }}
														</small>
													</span>
													<input
														name="customDeliveryRadioIcon"
														class="form-check-input"
														type="radio"
														value="renewal"
														id="customRadioIcon2"
														v-model="selectedType"
													/>
												</label>
											</div>
										</div>
									</div>
								</div>

								<div class="col-lg-8 mx-auto mt-5" v-if="displayOrderNumber">
									<h5>{{ $t('trainings.create.internalNumber') }}</h5>
									<div class="row gy-3">
										<div class="col-md">
											<input type="text" id="orderNumber" class="form-control" placeholder="PO12" v-model="orderNumber" />
										</div>
									</div>
								</div>

								<div class="col-lg-8 mx-auto" v-if="displayDGRPrice(selectedTraining)">
									<h5 class="my-6 mb-5">
										<span v-if="!displayOrderNumber">
											3.
										</span>
										<span v-else>
											4.
										</span> {{ $t('trainings.create.functionStep', { name: selectedTraining.title }) }}
									</h5>
									<div class="row gy-3">
										<div class="col-md">
											<div class="form-check custom-option custom-option-icon">
												<select id="defaultSelect" class="form-select" v-model="selectedVariant" @change="selectVariant">
													<option disabled>{{ $t('trainings.create.selectFunction') }}</option>
													<option value="generic" selected>{{ $t('trainings.create.genericVersion') }}</option>
													<option value="agent_fret" v-if="selectedTraining.formationName === 'DGR_7.4'">{{ $t('trainings.create.freightAgent') }}</option>
													<option value="agent_galerie" v-if="selectedTraining.formationName === 'DGR_7.4'">{{ $t('trainings.create.galleryAgent') }}</option>
													<option value="agent_piste" v-if="selectedTraining.formationName === 'DGR_7.4'">{{ $t('trainings.create.rampAgent') }}</option>
												</select>
											</div>
										</div>

										<div class="d-flex align-items-center" v-if="!hideTrainingsPrices">
											<div class="avatar avatar-md">
												<div class="avatar-initial bg-label-primary rounded-3">
													<i class="ri-price-tag-3-line ri-24px"></i>
													<!-- <i class="ri-money-euro-circle-line ri-24px"></i> -->
												</div>
											</div>
											<div class="ms-4">
												<p class="mb-0">
													{{ $t('trainings.create.trainingPrice', { price: selectedTraining.price, unit: billingMethod === 'invoices' ? '€ HT' : ' crédits' }) }}
												</p>
											</div>
										</div>
									</div>
								</div>

								<div class="col-lg-8 mx-auto mt-2 mb-5" v-if="displaySecurityCheck">
									<div class="form-check form-check-primary mt-4">
										<input class="form-check-input" type="checkbox" id="customCheckPrimary" v-model="securityCheckAcknowledged" />
										<label class="form-check-label" for="customCheckPrimary" style="font-size: 12px;">
										{{ $t('trainings.create.backgroundCheckWarning') }}</label>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div
						class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-6 row-gap-4">
						<div class="d-flex flex-column justify-content-center">

						</div>
						<div class="d-flex align-content-center flex-wrap gap-4 mt-5">
							<button class="btn btn-outline-secondary" @click="selectedTraining = null">{{ $t('common.actions.back') }}</button>
							<button type="submit" class="btn btn-primary" @click="showEmployees()" v-if="selectedType && securityCheckAcknowledged">{{ $t('common.actions.next') }}</button>
							<button type="submit" class="btn btn-primary disabled" v-else>{{ $t('common.actions.next') }}</button>
						</div>
					</div>
				</div>
			</div>

			<div class="row" v-if="displayEmployees">
				<div class="col-xs-12 col-12 col-lg-8 col-xl-8" v-if="selectedTraining">
					<div class="card card-action mb-5">
						<div class="card-header align-items-center">
							<h5 class="card-action-title mb-0">{{ $t('trainings.create.chooseTrainee', { type: displayType(), title: selectedTraining.title }) }}</h5>
						</div>
						<div class="card-body">
							<div class="form-floating form-floating-outline mb-5">
								<input
									type="text"
									class="form-control dt-input dt-full-name"
									data-column="1"
									:placeholder="$t('trainings.create.searchEmployee')"
									data-column-index="0"
									v-model="search"
									@input="fetchEmployees"
									autocomplete="off"
								/>
								<label>{{ $t('trainings.create.searchEmployee') }}</label>
							</div>
								
							<ul class="list-unstyled mb-0">
								<li
									class="mb-4 row-grey"
									v-for="(employee, index) in employees"
									:key="index"
								>
									<div class="d-flex align-items-center">
										<div class="d-flex align-items-center">
											<div class="avatar me-2">
												<img :src="`https://ui-avatars.com/api/?name=${employee.firstName}+${employee.lastName}&background=666cff&color=fff`" alt="Avatar" class="rounded-circle" />
											</div>
											<div class="me-2">
												<h6 class="mb-0">{{ employee.firstName }} {{ employee.lastName }}</h6>
												<small>{{ employee.email }}</small>
											</div>
										</div>
										<div class="ms-auto">
											<button
												class="btn btn-icon"
												:class="isSelected(employee) ? 'btn-primary' : 'btn-outline-primary'"
												@click="toggleEmployeeSelection(employee)"
											>
												<i v-if="isSelected(employee)" class="ri-check-fill"></i>
												<i v-else class="ri-user-add-line ri-22px"></i>
											</button>
										</div>
									</div>
								</li>
								<li class="text-center">
									<button type="button" class="btn btn-primary" @click="resetEmployeeForm()" data-bs-toggle="modal" data-bs-target="#createEmployee">
										{{ $t('employees.profile.addEmployee') }}
									</button>
								</li>
							</ul>
						</div>
					</div>
				</div>

				<div class="col-xs-12 col-12 col-xl-4">
					<div class="border rounded-4 p-5 mb-4">
						<h6>{{ $t('trainings.create.priceDetails', { title: selectedTraining.title }) }}</h6>
						<dl class="row mb-0">
							<!-- Liste des employés avec v-for -->
							<template v-for="(employee) in selectedEmployees" :key="employee.id">
								<dt
									:class="[
										hideTrainingsPrices ? 'col-12' : 'col-6',
										'fw-normal',
										'text-muted'
									]"
								>
									{{ employee.firstName }} {{ employee.lastName }}
								</dt>
								<dd class="col-6 text-end" v-if="!hideTrainingsPrices">
									{{ billingMethod === 'invoices' ? selectedTraining.price + '€ HT' : selectedTraining.price + ' crédits' }}
								</dd>
							</template>
						</dl>

						<hr class="mx-n5 my-5" />
						<dl class="row mb-0" v-if="!hideTrainingsPrices">
							<dt class="col-6 text-heading">Total</dt>
							<dd class="col-6 fw-medium text-heading text-end mb-0">
								{{ billingMethod === 'invoices' ? priceWithoutTaxes + '€ HT' : priceWithoutTaxes + ' crédits' }}
							</dd>
						</dl>
					</div>
					<div class="d-grid">
						<button class="btn btn-primary btn-next" @click="processTrainings()" v-if="selectedEmployees.length === 0" disabled>
							{{ $t('trainings.create.order') }}
						</button>
						<button class="btn btn-primary btn-next" @click="processTrainings()" v-if="!isWaitingStripe && selectedEmployees.length > 0">
							{{ displayConfirmationOrderCTAText() }}
						</button>
						<button class="btn btn-primary waves-effect waves-light" type="button" disabled="" v-if="isWaitingStripe">
							<span class="spinner-border me-1" role="status" aria-hidden="true"></span>
							{{ $t('common.loading') }}
						</button>
					</div>
				</div>
			</div>

			<div class="modal fade" id="createEmployee" tabindex="-1" aria-hidden="true">
				<div class="modal-dialog modal-dialog-centered1 modal-simple modal-add-new-cc">
					<div class="modal-content">
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						<div class="modal-body p-0">
							<div class="text-center mb-6">
								<h4 class="mb-2">
									{{ $t('employees.profile.addEmployee') }}
								</h4>
							</div>

							<form id="addTrainingForm" class="row g-5" onsubmit="return false">

								<div class="col-6">
									<div class="form-floating form-floating-outline">
										<input
											type="text"
											id="modalEditUserFirstName"
											name="modalEditUserFirstName"
											class="form-control"
											v-model="form.firstName"
											autocomplete="off"
										/>
										<label for="modalEditUserFirstName">{{ $t('employees.profile.firstName') }}</label>
										<small v-if="errors.firstName" class="text-danger">{{ errors.firstName }}</small>
									</div>
								</div>

								<div class="col-6">
									<div class="form-floating form-floating-outline">
										<input
											type="text"
											id="modalEditUserLastName"
											name="modalEditUserLastName"
											class="form-control"
											v-model="form.lastName"
											autocomplete="off"
										/>
										<label for="modalEditUserLastName">{{ $t('employees.profile.lastName') }}</label>
										<small v-if="errors.lastName" class="text-danger">{{ errors.lastName }}</small>
									</div>
								</div>

								<div class="col-12">
									<div class="form-floating form-floating-outline">
										<input
											type="email"
											id="modalEditUserFirstName"
											name="modalEditUserFirstName"
											class="form-control"
											v-model="form.email"
											autocomplete="off"
										/>
										<label for="modalEditUserFirstName">{{ $t('employees.profile.email') }}</label>
										<small v-if="errors.email" class="text-danger">{{ errors.email }}</small>
									</div>
								</div>

								<div class="col-md-12 col-12">
									<div class="form-floating form-floating-outline">
										<input type="text" id="bs-datepicker-basic" placeholder="MM/DD/YYYY" class="form-control" @input="handleDateInput" v-model="form.birthDate" autocomplete="off" />
										<label for="bs-datepicker-basic">{{ $t('employees.profile.birthDate') }}</label>
										<small v-if="errors.birthDate" class="text-danger">{{ errors.birthDate }}</small>
									</div>
								</div>

								<div class="col-md-12 col-12">
									<div class="input-group input-group-merge">
										<div class="form-floating form-floating-outline">
											<input
												type="text"
												id="modalCreateEmployeeSsn"
												name="modalCreateEmployeeSsn"
												class="form-control"
												placeholder="1 85 05 78 006 084 36"
												autocomplete="off"
												@input="handleSsnInput"
												v-model="form.socialSecurityNumber"
											/>
											<label for="modalCreateEmployeeSsn">{{ $t('common.fields.socialSecurityNumber') }}</label>
											<small v-if="errors.socialSecurityNumber" class="text-danger">{{ errors.socialSecurityNumber }}</small>
										</div>
										<span class="input-group-text" data-bs-toggle="tooltip" :data-bs-title="$t('employees.ssnInfo')">
											<i class="ri-information-line"></i>
										</span>
									</div>
								</div>

								<div class="col-md-12 col-12" v-if="displayAgencies">
									<div class="col-md">
										<div class="form-check custom-option custom-option-icon">
											<select id="defaultSelect" class="form-select" v-model="form.agency">
												<option value="" selected>{{ $t('employees.profile.selectBranch') }}</option>
												<option v-for="agency in agencies" :key="agency" :value="agency">
													{{ agency }}
												</option>
											</select>
										</div>
									</div>
								</div>

								<div class="col-12 d-flex flex-wrap justify-content-center gap-4 row-gap-4">
									<button type="submit" class="btn btn-primary" @click="createEmployee()">{{ $t('common.actions.save') }}</button>
									<button
										type="button"
										class="btn btn-outline-secondary btn-reset"
										data-bs-dismiss="modal"
										aria-label="Close">
										{{ $t('common.actions.cancel') }}
									</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>

			<div class="modal fade" id="displayWarning" tabindex="-1" aria-hidden="true">
				<div class="modal-dialog modal-dialog-centered1 modal-simple modal-add-new-cc" style="">
					<div class="modal-content">
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						<div class="modal-body p-0">

							<div class="text-center">
								<i class="ri-id-card-line" style="font-size: 42px;"></i>
								<p class="mt-5 mb-5">
									<strong>{{ $t('trainings.create.warningTitle') }}</strong>
								</p>

								<p>{{ $t('trainings.create.warningClassified') }}</p>

								<p>{{ $t('trainings.create.warningObligations') }}</p>

								<p>{{ $t('trainings.create.warningBlocked') }}</p>

								<p>
									{{ $t('trainings.create.warningContact') }}<br/>
									<a href="">contact@pika-aero.com</a><br />
									{{ $t('trainings.create.warningActivate') }}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>
		<!-- / Content -->

		<div class="content-backdrop fade"></div>
	</div>
</template>

<script>
import HTTP from "@/axios";
import { Tooltip } from "bootstrap"
import { formatNIR, isValidNIR, normalizeNIR } from "@/helpers/nir";

export default {
	name: "TrainingCreate",

	data() {
		return {
			search: null,
			searchTraining: null,
			searchTimeout: null,
			activeCategory: "all",
			company: null,
			orderNumber: null,
			taxes: 0,
			hasDiscount: false,
			priceWithoutTaxes: 0,
			isLoading: true,
			selectedTraining: null,
			selectedLanguage: "fr",
			selectedType: null,
			selectedVariant: null,
			displayEmployees: false,
			billingMethod: "credits",
			employees: [],
			selectedEmployees: [],
			trainings: [],
			isWaitingStripe: false,
			displayAgencies: false,
			displayOrderNumber: false,
			displaySecurityCheck: false,
			securityCheckAcknowledged: true,
			agencies: [],
			hideTrainingsPrices: false,
			form: {
				agency: "",
				firstName: "",
				lastName: "",
				email: "",
				birthDate: null,
				socialSecurityNumber: "",
				role: "trainee"
			},
			errors: {},
		};
	},

	methods: {
		selectVariant() {
			if (!this.selectedTraining)
				return;

			if (this.selectedTraining.formationName !== "DGR_7.4")
				return;

			if (this.selectedVariant === "agent_galerie") {
				// Save original price

				if (this.billingMethod === "credits")
					this.selectedTraining.price = 17;
				else {
					if (this.company.name === "TRIANGLE ROISSY")
						this.selectedTraining.price = 80;
					else
						this.selectedTraining.price = 85;
				}
			}
			else {
				// Set old price
				this.selectedTraining.price = this.oldPrice;
			}
		},

		initTooltips() {
			// Détruire les anciennes instances
			const tooltipTriggerList = this.$el.querySelectorAll('[data-bs-toggle="tooltip"]');
			tooltipTriggerList.forEach((el) => {
				const existingTooltip = Tooltip.getInstance(el);
				if (existingTooltip) {
					existingTooltip.dispose();
				}
			});

			// Créer les nouvelles instances
			this.$nextTick(() => {
				const newTooltipTriggerList = this.$el.querySelectorAll('[data-bs-toggle="tooltip"]');
				newTooltipTriggerList.forEach((el) => {
					new Tooltip(el);
				});
			});
		},

		formatDuration(hours) {
			const fullHours = Math.floor(hours)
			const minutes = Math.round((hours - fullHours) * 60)

			if (minutes === 0)
				return `${fullHours} heures`
				
			return `${fullHours}h${minutes}`
		},

		async fetchFeatureFlag() {
			const response = await HTTP.get("/company/flags");

			// Features flags
			this.displayAgencies = response.data.displayAgencies;
			this.displayOrderNumber = response.data.displayOrderNumber;
			this.agencies = response.data.agencies;
			this.hideTrainingsPrices = response.data.hideTrainingsPrices;
		},

		async fetchCompany() {
			try {
				const response = await HTTP('/company');
				this.company = response.data.company;
			} catch (error) {
				// Récupérer le message d'erreur de l'API ou définir un message par défaut
				const errorMessage = error?.response?.data?.message || this.$t('errors.generic');

				alert(errorMessage);

				// Log détaillé dans la console (utile en développement)
				console.error("Erreur API:", error);
			}
		},

		getEmployeeFirstname(selectedId) {
			const employee = this.employees.find(emp => String(emp._id) === String(selectedId));
			return employee;
		},

		selectTraining(training) {
			this.selectedTraining = training;

			// Permis T
			// if (this.selectedTraining.formationName.includes("11.2.6.2")) {
			// 	return this.$router.push("/trainings/permis-t");
			// }

			// Dislay Security Check
			if (this.selectedTraining.formationName.includes("11.2.3.")) {
				this.displaySecurityCheck = true;
				// Opt-out par défaut pour les formations sensibles (case décochée)
				this.securityCheckAcknowledged = false;
			}
			else {
				this.displaySecurityCheck = false;
				// Pas de blocage pour les formations normales
				this.securityCheckAcknowledged = true;
			}

			if (this.selectedTraining.certificateType === "dgr") {
				this.selectedVariant = "generic";

				// Save old price
				this.oldPrice = this.selectedTraining.price;
			}
		},

		displayWarning() {
			const modalElement = document.getElementById("displayWarning");
			let modal = window.bootstrap.Modal.getInstance(modalElement);

			if (!modal) {
				modal = new window.bootstrap.Modal(modalElement);
			}

			modal.show();
		},

		showEmployees() {
			if (this.displayOrderNumber) {
				if (!this.orderNumber)
					return alert(this.$t('trainings.create.orderNumberRequired'))
			}

			this.displayEmployees = true;
		},

		displayType() {
			if (this.selectedType === "renewal")
				return this.$t('common.trainingTypes.renewal').toLowerCase();

			return this.$t('common.trainingTypes.initial').toLowerCase();
		},

		displayDGRPrice(training) {
			if (training.certificateType === "dgr")
				return true;

			return false;
		},

		displayOrderCTAText(training) {
			if (training.certificateType === "dgr")
				return this.$t('trainings.create.configureTraining');

			if (this.hideTrainingsPrices)
				return this.$t('trainings.create.selectTraining');

			return this.$t('trainings.create.chooseTraining', { price: this.billingMethod === 'invoices' ? training.price + '€ HT' : training.price + ' crédits' });
		},

		displayConfirmationOrderCTAText() {
			if (this.hideTrainingsPrices)
				return this.$t('trainings.create.orderTrainings');

			return this.$t('trainings.create.orderFor', { price: this.priceWithoutTaxes, unit: this.billingMethod === 'invoices' ? '€ HT' : ' crédits' });
		},

		handleDateInput(event) {
			let input = event.target.value;

			// Enlever tous les caractères non numériques
			input = input.replace(/\D/g, '');

			// Formatage automatique en DD/MM/YYYY
			if (input.length <= 2) {
				this.form.birthDate = input;
			} else if (input.length <= 4) {
				this.form.birthDate = `${input.slice(0, 2)}/${input.slice(2)}`;
			} else {
				this.form.birthDate = `${input.slice(0, 2)}/${input.slice(2, 4)}/${input.slice(4, 8)}`;
			}
		},

		handleSsnInput(event) {
			this.form.socialSecurityNumber = formatNIR(event.target.value);
		},

		validateEmail(email) {
			const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			return re.test(email);
		},

		validateForm() {
			this.errors = {};

			if (!this.form.firstName) {
				this.errors.firstName = this.$t('validation.firstNameRequired');
			}

			if (!this.form.lastName) {
				this.errors.lastName = this.$t('validation.lastNameRequired');
			}

			if (!this.form.email || !this.validateEmail(this.form.email)) {
				this.errors.email = this.$t('validation.emailInvalid');
			}

			if (!this.form.birthDate) {
				this.errors.birthDate = this.$t('validation.birthDateRequired');
			}

			if (this.form.socialSecurityNumber && !isValidNIR(this.form.socialSecurityNumber)) {
				this.errors.socialSecurityNumber = this.$t('validation.invalidSocialSecurityNumber');
			}

			return Object.keys(this.errors).length === 0;
		},

		resetEmployeeForm() {
			this.form = {
				agency: "",
				firstName: "",
				lastName: "",
				email: "",
				birthDate: null,
				socialSecurityNumber: "",
				role: "trainee"
			};

			this.errors = {};
		},

		async createEmployee() {
			const validated = this.validateForm();

			if (!validated)
				return;

			if (this.displayAgencies && this.form.agency === "")
				return alert(this.$t('trainings.create.selectBranchRequired'))

			const payload = { ...this.form };

			if (!payload.birthDate)
				delete payload.birthDate;

			if (!this.displayAgencies)
				payload.agency = null;

			if (payload.socialSecurityNumber)
				payload.socialSecurityNumber = normalizeNIR(payload.socialSecurityNumber);
			else
				delete payload.socialSecurityNumber;

			try {
				await HTTP.post('/company/employees/create', payload);

				document.activeElement?.blur();
				
				const modal = window.bootstrap.Modal.getInstance(document.getElementById("createEmployee"));
				try {
					modal.hide();
				}
				catch (err) {
					console.log('[Training] Unable to hide modal')
				}

				// Clean
				setTimeout(() => {
					document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
					document.body.style.overflow = '';
					document.body.style.paddingRight = '';
					document.body.classList.remove('modal-open');
					window.scrollTo(0, 0);
				}, 500)

				this.resetEmployeeForm();

				this.fetchEmployees();
			} catch (error) {
				// Récupérer le message d'erreur de l'API ou définir un message par défaut
				const errorMessage = error?.response?.data?.message || this.$t('errors.generic');

				alert(errorMessage);
				// Log détaillé dans la console (utile en développement)
				console.error("Erreur API:", error);
			}
		},

		isSelected(employee) {
			// Vérifie si l'employé est dans la liste des employés sélectionnés
			return this.selectedEmployees.some(e => e._id === employee._id);
		},

		toggleEmployeeSelection(employee) {
			// Ajoute ou retire l'employé de la liste des employés sélectionnés
			if (this.isSelected(employee)) {
				this.selectedEmployees = this.selectedEmployees.filter((e) => e._id !== employee._id);
			} else {
				this.selectedEmployees.push(employee);
			}

			this.calculatePrice();
			this.search = null;
			this.fetchEmployees();
		},

		calculatePrice() {
			if (!this.selectedTraining.price)
				this.selectedTraining.price = 0;

			this.priceWithoutTaxes = (this.selectedEmployees.length * this.selectedTraining.price);

			// Arrondir les valeurs à 2 décimales
			this.priceWithoutTaxes = parseFloat(this.priceWithoutTaxes.toFixed(2));
		},

		async processTrainings() {
			this.isWaitingStripe = true;

			if (!this.displayOrderNumber)
				this.orderNumber = null;

			if (!this.selectedLanguage)
				this.selectedLanguage = "fr";

			try {
				await HTTP.post('/trainings/assign-an-employee', {
					employeesIds: this.selectedEmployees.map(e => e._id),
					formationName: this.selectedTraining.formationName,
					type: this.selectedType,
					orderNumber: this.orderNumber,
					language: this.selectedLanguage,
					variant: this.selectedVariant
				});

				this.$router.push("/trainings/success");
			} catch (error) {
				this.isWaitingStripe = false;

				// Récupérer le message d'erreur de l'API ou définir un message par défaut
				const errorMessage = error?.response?.data?.message || this.$t('errors.generic');

				alert(errorMessage);

				// Log détaillé dans la console (utile en développement)
				console.error("Erreur API:", error);
			}
		},

		async fetchEmployees() {
			try {
				const response = await HTTP('/company/employees', { params: { limit: 30, search: this.search } });
				this.employees = response.data.employees;
			} catch (error) {
				// Récupérer le message d'erreur de l'API ou définir un message par défaut
				const errorMessage = error?.response?.data?.message || this.$t('errors.generic');

				alert(errorMessage);

				// Log détaillé dans la console (utile en développement)
				console.error("Erreur API:", error);
			}
		},

		async fetchTrainings() {
			try {
				const response = await HTTP('/trainings');

				this.trainings = response.data.formations;
				this.billingMethod = response.data.billingMethod ? response.data.billingMethod : "credits";
				this.hasDiscount = response.data.hasDiscount;

				this.isLoading = false;
				this.initTooltips();
			} catch (error) {
				// Récupérer le message d'erreur de l'API ou définir un message par défaut
				const errorMessage = error?.response?.data?.message || this.$t('errors.generic');

				alert(errorMessage);

				// Log détaillé dans la console (utile en développement)
				console.error("Erreur API:", error);
			}
		},

		getLanguageName(code) {
			const languages = {
				'fr': 'Français',
				'en': 'English',
				'es': 'Español',
				'de': 'Deutsch'
			};
			return languages[code] || code;
		}
	},

	async mounted() {
		const search = this.$route.query.search;
		if (search) this.searchTraining = String(search);

		await this.fetchCompany();
		if (!search && this.company && this.company.name) {
			const name = this.company.name.toUpperCase();
			if (name.includes("SGS") || name.includes("ALLTRANSPACK"))
				this.activeCategory = "dgr";
		}
		this.fetchTrainings();
		this.fetchEmployees();
		this.fetchFeatureFlag();
	},

	watch: {
		searchTraining(newVal) {
			if (this.searchTimeout) clearTimeout(this.searchTimeout);

			if (newVal && newVal.trim()) {
				this.searchTimeout = setTimeout(() => {
					HTTP.post('/trainings/log-search', {
						search: newVal.trim()
					}).catch(() => {});
				}, 1000);
			}
		}
	},

	computed: {
		sortedTrainings() {
			// Filtre par catégorie
			let filtered = this.trainings;

			if (this.activeCategory === 'packs') {
				filtered = filtered.filter(t => t.title && t.title.includes('+'));
			} else if (this.activeCategory !== 'all') {
				filtered = filtered.filter(t => t.certificateType === this.activeCategory);
			}

			// Filtre selon la recherche
			if (this.searchTraining && this.searchTraining.trim() !== '') {
				const searchTerm = this.searchTraining.toLowerCase().trim();
				const searchWords = searchTerm.split(' ').filter(word => word.length > 0);

				filtered = filtered.filter(training => {
					if (searchWords.some(word => word.startsWith('tca'))) {
						return (training.formationName && training.formationName.startsWith('11.2.6.2')) || (training.formationName && training.formationName.toLowerCase().includes('tca'));
					}

					if (searchWords.some(word => word.startsWith('pack'))) {
						return training.title && training.title.includes('+');
					}

					// Cas spécial pour "sur" ou "sûr"
					if (searchWords.some(word => word.startsWith('sur') || word.startsWith('sûr'))) {
						return training.formationName && training.formationName.startsWith('11.2.3');
					}

					// Concatène tous les champs recherchables
					const searchableText = [
						training.formationName,
						training.longTitle,
						training.description
					]
						.filter(field => field)
						.join(' ')
						.toLowerCase();

					// Vérifie que tous les mots de la recherche sont présents
					return searchWords.every(word => searchableText.includes(word));
				});
			}

			// Puis trie par order et RETOURNE le résultat
			return [...filtered].sort((a, b) => a.order - b.order);
		}
	}
};
</script>

<style scoped>
.load-center {
	display: block;
	margin: 0 auto;
}

/* Ajoutez des styles spécifiques à la page Dashboard */
.dashboard {
	padding: 1rem;
}

.card-title {
	font-size: 1.2rem;
}

.card-text {
	margin: 0;
}

.modal-simple .modal-content {
	padding: 3rem;
}

.pb-20 {
	padding-bottom: 20px;
}

.row-grey {
  background-color: #f5f5f5;
}

.row-grey {
  padding: 12px;
  border-radius: 6px;
}
</style>
